<template>
    <div class="modal fade" id="client-create-modal-client" tabindex="-1" aria-labelledby="client-create-modal-client" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content modern-modal">
                <div class="modal-header border-0 pb-0">
                    <div>
                        <h5 class="modal-title mb-0">
                            <AppIcon name="bi-person-plus-fill" class="bi bi-person-plus-fill me-2" />
                            {{$t('create_client')}}
                        </h5>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body pt-2" style="text-align:left">
                    <div class="client-form-fields">
                        <div class="client-form-field">
                            <label for="createLabelInput" class="form-label">
                                {{$t('label')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-person" class="bi bi-person" />
                                </span>
                                <input 
                                    v-model="client.name" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    :class="{'is-invalid': validationErrors.name}"
                                    id="createLabelInput"
                                    @blur="validateField('name')"
                                >
                            </div>
                            <div v-if="validationErrors.name" class="invalid-feedback d-block">
                                {{validationErrors.name}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('phone')" class="client-form-field">
                            <label for="createPhoneInput" class="form-label">
                                {{$t('phone')}} <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-telephone" class="bi bi-telephone" />
                                </span>
                                <input 
                                    v-model="client.phone" 
                                    type="tel" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.phone}"
                                    id="createPhoneInput"
                                    @blur="validateField('phone')"
                                >
                            </div>
                            <div v-if="validationErrors.phone" class="invalid-feedback d-block">
                                {{validationErrors.phone}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('email')" class="client-form-field">
                            <label for="createEmailInput" class="form-label">{{$t('email')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-envelope" class="bi bi-envelope" />
                                </span>
                                <input 
                                    v-model="client.email" 
                                    type="email" 
                                    class="form-control border-start-0 ps-0"
                                    :class="{'is-invalid': validationErrors.email}"
                                    id="createEmailInput"
                                    @blur="validateField('email')"
                                >
                            </div>
                            <div v-if="validationErrors.email" class="invalid-feedback d-block">
                                {{validationErrors.email}}
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('address')" class="client-form-field client-form-field--full">
                            <label for="createAddressInput" class="form-label">{{$t('address')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-house" class="bi bi-house" />
                                </span>
                                <textarea 
                                    v-model="client.address" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createAddressInput" 
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('city')" class="client-form-field">
                            <label for="createCityInput" class="form-label">{{$t('city')}}</label>
                            <input v-model="client.city" type="text" class="form-control" id="createCityInput">
                        </div>
                        <div v-if="isClientFieldVisible('state')" class="client-form-field">
                            <label for="createStateInput" class="form-label">{{$t('state')}}</label>
                            <input v-model="client.state" type="text" class="form-control" id="createStateInput">
                        </div>
                        <div v-if="isClientFieldVisible('zip_code')" class="client-form-field">
                            <label for="createZipCodeInput" class="form-label">{{$t('zip_code')}}</label>
                            <input v-model="client.zip_code" type="text" class="form-control" id="createZipCodeInput">
                        </div>
                        <div v-if="isClientFieldVisible('country')" class="client-form-field">
                            <label for="createCountryInput" class="form-label">{{$t('country')}}</label>
                            <input v-model="client.country" type="text" class="form-control" id="createCountryInput">
                        </div>
                        <div v-if="clientCurrencyEnabled && isClientFieldVisible('currency')" class="client-form-field">
                            <label for="createClientCurrencyInput" class="form-label">{{$t('currency')}}</label>
                            <select v-model="client.currency" class="form-select" id="createClientCurrencyInput">
                                <option value="">{{$t('default')}} ({{business.currency}})</option>
                                <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                                    {{option.label}}
                                </option>
                            </select>
                        </div>
                        <div v-if="isClientFieldVisible('tax_id')" class="client-form-field">
                            <label for="createTaxIdInput" class="form-label">{{$t('tax_id')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="client.tax_id" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createTaxIdInput"
                                >
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('vat_number')" class="client-form-field">
                            <label for="createVatNumberInput" class="form-label">{{$t('vat_number')}}</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0">
                                    <AppIcon name="bi-hash" class="bi bi-hash" />
                                </span>
                                <input 
                                    v-model="client.vat_number" 
                                    type="text" 
                                    class="form-control border-start-0 ps-0" 
                                    id="createVatNumberInput"
                                >
                            </div>
                        </div>
                        <div v-if="isClientFieldVisible('notes')" class="client-form-field client-form-field--full">
                            <collapsible-notes-field v-model="client.notes" id="client-notes" rows="2" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}
                    </button>
                    <button type="button" class="btn btn-success" :disabled="loading || !isFormValid" @click="save">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <AppIcon name="bi-check-circle" v-else class="bi bi-check-circle me-2" />
                        {{$t('create')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
</template>

<script>
import helper from '../helper'
import { CURRENCY_OPTIONS } from '../constants/currencies'
import { getCrmClientFormFieldDefaults } from '../constants/crmClientFormFields'
export default {
  name: 'AddClient',
  props : ['state'],
  data(){
    return {
        client : {
            id : null,
            name : '',
            email : '',
            phone : '',
            ice : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            currency: '',
            tax_id: '',
            vat_number: '',
        },
        createModal : null,
        loading : false,
        validationErrors: {
            name: '',
            email: '',
            phone: ''
        }
    }
  },
  computed: {
    business() {
        return this.$store.getters.BUSINESS
    },
    clientCurrencyEnabled() {
        return !!this.business?.metadata?.use_client_currency_for_invoices
    },
    clientFormFields() {
        return {
            ...getCrmClientFormFieldDefaults(),
            ...(this.business?.metadata?.crm_client_form_fields || {}),
            name: true
        }
    },
    currencyOptions() {
        return CURRENCY_OPTIONS
    },
    isFormValid() {
        const hasRequiredPhone = !this.isClientFieldVisible('phone') || !!this.client.phone
        return this.client.name && hasRequiredPhone && !this.validationErrors.name && !this.validationErrors.phone && !this.validationErrors.email
    }
  },
  mounted(){
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('client-create-modal-client'), {backdrop: 'static', keyboard: false})
    if(this.state === true){
       this.createModal.show()
    }

    document.getElementById('client-create-modal-client').addEventListener('hidden.bs.modal', () => { 
        this.$emit('createClient',{state : false })
    })

  },
  methods : {
    isClientFieldVisible(field) {
        return this.clientFormFields[field] !== false
    },
    validateField(field) {
        if (field === 'name') {
            if (!this.client.name || this.client.name.trim() === '') {
                this.validationErrors.name = this.$t('name_required') || 'Name is required'
            } else if (this.client.name.length < 2) {
                this.validationErrors.name = this.$t('name_too_short') || 'Name must be at least 2 characters'
            } else {
                this.validationErrors.name = ''
            }
        }
        
        if (field === 'phone') {
            if (!this.isClientFieldVisible('phone')) {
                this.validationErrors.phone = ''
                return
            }
            if (!this.client.phone || this.client.phone.trim() === '') {
                this.validationErrors.phone = this.$t('phone_required') || 'Phone is required'
            } else {
                this.validationErrors.phone = ''
            }
        }
        
        if (field === 'email' && !this.isClientFieldVisible('email')) {
            this.validationErrors.email = ''
        } else if (field === 'email' && this.client.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.client.email)) {
                this.validationErrors.email = this.$t('invalid_email') || 'Invalid email format'
            } else {
                this.validationErrors.email = ''
            }
        } else if (field === 'email') {
            this.validationErrors.email = ''
        }
    },
    validateForm() {
        this.validateField('name')
        if (this.isClientFieldVisible('phone')) this.validateField('phone')
        if (this.isClientFieldVisible('email')) this.validateField('email')
        
        return !this.validationErrors.name && !this.validationErrors.phone && !this.validationErrors.email
    },
    async save(){
        if (!this.validateForm()) {
            this.$swal.fire({
                icon: 'error',
                title: this.$t('validation_error') || 'Validation Error',
                text: this.$t('please_fix_errors') || 'Please fix the errors before submitting'
            })
            return
        }

        try{
            this.loading = true
            const response = await helper.customPost(`${process.env.VUE_APP_API}/clients`,this.client,{showToast:true})
            this.loading = false
            this.clearForm()
            this.$emit('createClient',{client : response.data, state : false })
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    clearForm(){
        this.client = {
            id : null,
            name : '',
            email : '',
            phone : '',
            address : '',
            notes : '',
            city: '',
            state: '',
            zip_code: '',
            country: '',
            currency: '',
            tax_id: '',
            vat_number: '',
        }
        this.validationErrors = {
            name: '',
            email: '',
            phone: ''
        }
    }
  }
}
</script>

<style scoped>
.client-form-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.client-form-field {
    flex: 1 1 15rem;
    min-width: 0;
}

.client-form-field--full {
    flex-basis: 100%;
}
</style>
